

































import { Component, Vue, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'

@Component

export default class ComponenteBackofficeEnviaCodigoPrestadorSolicitante extends Vue {
  $refs!: { formCodigoPrestadorSolicitante: any }

  @Prop({ default: false }) disabled: boolean

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  codigoPrestadorSolicitanteRules: any = {
    valid: false,
    codigoPrestadorSolicitante: [v => !!v || 'Campo obrigatório'],
  }

  get getCodigoPrestadorSolicitante() {
    const { codigoPrestadorSolicitante } = this.getBackofficeGlobalStore.solicitacao
    return codigoPrestadorSolicitante || ''
  }

  set getCodigoPrestadorSolicitante(value: string) {
    this.getBackofficeGlobalStore.setCodigoPrestadorSolicitante(value)
  }
}
